<div class="pa-wrap">
  <div class="pa-calendar-block">
    <div class="pa-header">
      <button type="button" class="pa-nav-btn" (click)="prevMonth()"><i class="ri-arrow-left-s-line"></i></button>
      <div class="pa-month-label">{{ monthLabel }}</div>
      <button type="button" class="pa-nav-btn" (click)="nextMonth()"><i class="ri-arrow-right-s-line"></i></button>
    </div>

    <div class="pa-progress-row">
      <div class="pa-progress-track">
        <div class="pa-progress-fill" [style.width.%]="attendancePercentage"></div>
      </div>
      <span class="pa-progress-value">{{ attendancePercentage }}%</span>
    </div>

    <div class="pa-error" *ngIf="error">{{ error }}</div>

    <div class="pa-calendar" *ngIf="!loading; else paLoading">
      <div class="pa-weekday" *ngFor="let w of weekdayLabels">{{ w }}</div>

      <button type="button" class="pa-day" *ngFor="let day of calendarDays"
        [class.pa-day-out]="!day.inMonth"
        [class.pa-day-future]="day.isFuture"
        [class.pa-day-present]="day.status === 'PRESENT'"
        [class.pa-day-absent]="day.status === 'ABSENT'"
        [class.pa-day-late]="day.status === 'LATE'"
        [class.pa-day-leave]="day.status === 'LEAVE'"
        [class.pa-day-partial]="day.status === 'PARTIAL'"
        [class.pa-day-selected]="day.dateKey === selectedDateKey"
        [disabled]="day.status !== 'PARTIAL' || day.isFuture || !day.inMonth"
        (click)="onDayClick(day)">
        {{ day.date.getDate() }}
      </button>
    </div>

    <ng-template #paLoading>
      <div class="pa-calendar-skeleton"></div>
    </ng-template>

    <div class="pa-legend">
      <div class="pa-legend-item"><span class="pa-legend-dot pa-legend-present"></span>{{ 'present' | translate }}</div>
      <div class="pa-legend-item"><span class="pa-legend-dot pa-legend-absent"></span>{{ 'absent' | translate }}</div>
      <div class="pa-legend-item"><span class="pa-legend-dot pa-legend-late"></span>{{ 'late' | translate }}</div>
      <div class="pa-legend-item"><span class="pa-legend-dot pa-legend-none"></span>{{ 'noAttendance' | translate }}</div>
      <div class="pa-legend-item"><span class="pa-legend-dot pa-legend-leave"></span>{{ 'leave' | translate }}</div>
      <div class="pa-legend-item" *ngIf="attendanceType === 'PERIOD'"><span class="pa-legend-dot pa-legend-partial"></span>{{ 'partiallyPresent' | translate }}</div>
    </div>
  </div>

  <div class="pa-period-section" *ngIf="selectedDate">
    <div class="pa-period-header">
      <h4>{{ 'partiallyPresent' | translate }}</h4>
      <button type="button" class="pa-period-close" (click)="closePeriodDetails()"><i class="ri-close-line"></i></button>
    </div>

    <div class="pa-period-loading" *ngIf="periodLoading"><i class="ri-loader-4-line pa-spin"></i></div>
    <div class="pa-period-error" *ngIf="periodError">{{ periodError }}</div>

    <div class="pa-period-card" *ngFor="let p of periodDetails">
      <div class="pa-period-card-top">
        <div class="pa-period-subject">{{ p.subject }}</div>
        <span class="pa-period-pill" [class.pa-pill-present]="p.Attendance === 'PRESENT'"
          [class.pa-pill-absent]="p.Attendance === 'ABSENT'" [class.pa-pill-late]="p.Attendance === 'LATE'">
          {{ p.Attendance === 'PRESENT' ? ('present' | translate) : (p.Attendance === 'ABSENT' ? ('absent' | translate) : ('late' | translate)) }}
        </span>
      </div>
      <div class="pa-period-card-bottom">
        <img *ngIf="p.staffImage" [src]="p.staffImage" class="pa-period-staff-photo" alt="" />
        <span>{{ p.staffName }}</span>
        <span class="pa-period-dot">&middot;</span>
        <span>{{ formatPeriodTime(p.periodStart) }} - {{ formatPeriodTime(p.periodEnd) }}</span>
      </div>
    </div>
  </div>
</div>
